import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  getEndedFromStatusLabel,
  type EndedProviderRow,
} from "./ended-provider-types";

export function ReinstateProviderDialog({
  target,
  isPending,
  onCancel,
  onConfirm,
}: {
  target: EndedProviderRow | null;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={target !== null}
      onOpenChange={(open) => {
        if (!open && !isPending) {
          onCancel();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reinstate {target?.name}?</DialogTitle>
          <DialogDescription>
            They&apos;ll return to your roster as{" "}
            {target ? getEndedFromStatusLabel(target.endedFromStatus) : ""} and
            your credential record for them will resume. Pool memberships are
            not restored.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="border-t pt-4 sm:space-x-0">
          <Button variant="outline" onClick={onCancel} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isPending}>
            {isPending ? (
              <span className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                Reinstating...
              </span>
            ) : (
              "Reinstate"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
